import { LitElement } from 'lit';
export class BaseElement extends LitElement {
}
//# sourceMappingURL=BaseElement.js.map